import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';

const routes: Array<RouteConfig> = [
  {
    path: 'payment/thanks',
    component: () => import('@/pages/payment/SuccessPage.vue'),
    meta: {
      back: handlers.home
    }
  },
  {
    path: 'payment/finance',
    component: () => import('@/pages/payment/FinancialSynergyPage.vue'),
    meta: {
      back(this: Vue): string {
        return `/quote/${this.$packageHash}/payment`
      }
    }
  },
  {
    path: 'payment',
    component: () => import('@/pages/payment/PaymentPage.vue'),
    children: [{ path: ':id' }],
    meta: {
      back(this: Vue): string {
        return `/quote/${this.$packageHash}/apply`;
      }
    }
  },
];

export default routes;
